import { format } from 'date-fns';
import React from 'react'
import { formatTime } from 'src/coach/service/coach.utils';
import { Button, Modal } from 'src/shared';
import { ShortWeekdays } from '../availability/helper';

function ConfirmConflictingDates({
  conflictingPeriods = [],
  onClose,
  onConfirm,
  actions
}) {
  return (
     <Modal $title="Conflicting Dates" $actions={actions}>
      <Modal.Content>
          <div>
          {conflictingPeriods?.map(
            (
              {
                conflictingDateTimes,
                dayOfWeek,
                endDate,
                endTime,
                id,
                startDate,
                startTime,
              },
              index,
            ) => {
              return (
               <div className="tw-flex tw-flex-col tw-gap-2 tw-mb-1" key={id || index}>
                  <p>
                    Your Availability on {ShortWeekdays[dayOfWeek]} from{' '}
                    {formatTime(startTime)} to {formatTime(endTime)} within the
                    date range of {format(new Date(startDate), 'MM/dd/yyyy')} to{' '}
                    {format(new Date(endDate), 'MM/dd/yyyy')} conflicts with the
                    following dates:
                  </p>
                  <div className='datesList'>
                    <div className='tw-font-bold item '>
                      <p>Date</p>
                      <p>Times</p>
                    </div>
                    {conflictingDateTimes?.map((dateTime) => (
                      <div className='item' key={dateTime?.id}>
                        <p>
                          <p>
                            {format(
                              new Date(dateTime?.date),
                              'MM/dd/yyyy, EEE',
                            )}
                          </p>
                        </p>
                        <p>
                          {formatTime(dateTime?.startTime)} -{' '}
                          {formatTime(dateTime?.endTime)}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              );
            },
          )}
        </div>
      </Modal.Content>
      


      <Modal.Footer className="flex align-center justify-flex-end tw-gap-1">
        <Button
         className="ml-12 outline tw-text-red tw-border-red" 
        onClick={onClose}
        >
          Close
        </Button>
        <Button 
          type="button"
          onClick={onConfirm} variant="contained">
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmConflictingDates;
